import styles from './index.module.less'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className={styles.page}>
      <div>
        <img
          src="https://techcenter-common-storage-1251001122.cos.ap-shanghai.myqcloud.com//bigdata/files/1739864807248899464.svg"
          alt="404"
          className={styles.img}
        />
        <div className={styles.title}>404</div>
        <div className={styles.desc}>
          您访问的页面找不到了
        </div>
        <div className={styles.btn}>
          <Button type="primary" onClick={() => navigate('/guide')}>
            返回首页
          </Button>
        </div>
      </div>
    </div>
  )
}
